import React, { Fragment } from 'react'
import Router from 'next/router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import env from 'config/env'
import styles from './style.scss'

const ShopNowButton = ({ internationalization: { country, language }, t }) => {
  const shopNowCtaKey = 'TTBH_PRODUCT_CTA_SHOP_NOW_DISABLED'
  const shopNowCtaVal = 'SHOP NOW'

  const onLinkClicked = (e) => {
    e?.preventDefault()
    e?.stopPropagation()

    Router.push(
      `/category?id=${env.TTB_CATEGORY_ID}`,
      `/${country}/${language}/clothes/best-sellers`,
    )
  }

  return (
    <Fragment>
      <style jsx>{styles}</style>
      <div
        className={clsx('shopnow-btn', Typo.button)}
        role="button"
        onClick={onLinkClicked}
        onKeyDown={onLinkClicked}
        tabIndex="0"
      >
        {hasLocizeTranslation(t, shopNowCtaKey, shopNowCtaVal)}
      </div>
    </Fragment>
  )
}

ShopNowButton.propTypes = {
  internationalization: PropTypes.shape({
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(ShopNowButton)

export default connect((state) => ({
  internationalization: state.internationalization,
}))(Extended)
